<button
	focus
	activeDarken
	class="whitespace-nowrap w-full hover-layer flex items-center justify-between p-4 rounded-3xl cursor-pointer duration-50 h-24 bg-neutral-50 dark:bg-neutral-900"
	(click)="onExpand()">
	<div class="flex items-center">
		@if (item().icon) {
			<app-icon
				[ngClass]="iconClass"
				class="icon-size-7 mr-3"
				[svgIcon]="item().icon"></app-icon>
		}
		@if (item().title) {
			<span class="text-md"> {{ item().title | transloco }}</span>
		}
	</div>
</button>

@if (expanded() && item().type === 'aside') {
	<div
		@expandCollapse
		class="flex flex-col items-start w-full gap-0.5 py-0.5 overflow-hidden">
		<ng-content></ng-content>
	</div>
}
